import { render, staticRenderFns } from "./VipStatistic.vue?vue&type=template&id=7e3b6e71&scoped=true&"
import script from "./VipStatistic.vue?vue&type=script&lang=js&"
export * from "./VipStatistic.vue?vue&type=script&lang=js&"
import style0 from "./VipStatistic.vue?vue&type=style&index=0&id=7e3b6e71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3b6e71",
  null
  
)

export default component.exports